import {postJobBoardMilestone} from '../../../feature/jobBoard/jobBoard';

window.addEventListener('load', () => {
  postJobBoardMilestone('see-landing');
});
